import { graphql } from 'gatsby'
import React from 'react'

import { AboutQueryQuery } from '../../types/graphql-types'
import EnhancedMeta from '../components/meta/enhanced-meta'
import Layout from '../components/layout/layout'
import Team from '../components/team'
import Appointment from '../components/appointment'
import { generateLocalBusinessSchema } from '../utils/schema-generator'

interface Props {
  data: AboutQueryQuery
  location: Location
}

const Index: React.FC<Props> = ({ data, location }: Props) => {
  const meta = data.site?.meta
  const localBusinessSchema = generateLocalBusinessSchema()

  return (
    <Layout location={location}>
      <EnhancedMeta
        title="About Us | Expert Aesthetic Practitioners | Ada Aesthetics Cheshunt"
        description="Meet the expert team at Ada Aesthetics in Cheshunt, Hertfordshire. Qualified aesthetic practitioners delivering natural-looking results for Botox, fillers & beauty treatments. 500+ satisfied clients."
        keywords="about Ada Aesthetics, Cheshunt aesthetic clinic, qualified practitioners, aesthetic nurse Hertfordshire"
        url="https://adaaesthetics.uk/about"
        schemaData={localBusinessSchema}
        site={meta}
      />
      <Team />
      <Appointment />
    </Layout>
  )
}

export default Index

export const pageQuery = graphql`
  query AboutQuery {
    site {
      meta: siteMetadata {
        title
        description
        siteUrl
        author
      }
    }
  }
`
